'use client';

import { Button } from '@common/components';
import { cn } from '@core/utils';

import { NewBadge } from '@/app/donation/_components/NewBadge';
import { Image } from '@/components/client';

interface SpecialtiesItemProps {
  imageUrl: string;
  specialtyName: string;
  institutionName: string;
  isNew?: boolean;
  active?: boolean;
  onClick?: () => void;
}

/** 데스크톱에서 사용되는 컴포넌트 */
export const DesktopSpecialtiesItem = ({
  imageUrl,
  specialtyName,
  institutionName,
  isNew,
  active,
  onClick,
}: SpecialtiesItemProps) => {
  return (
    <Button
      className={cn(
        'relative flex size-fit flex-col items-center gap-4 border-0 p-0 pb-8',
        {
          'rounded-medium bg-Gray-50': active,
        },
      )}
      theme="sub-text"
      onClick={() => onClick?.()}
    >
      <Image
        src={imageUrl}
        className="m-4 size-48 object-cover"
        alt={`${specialtyName} 이미지`}
        width={48 * 2}
        height={48 * 2}
      />
      <p
        className={cn('font-600 text-Gray-600 typo-caption1', {
          'font-700 text-Gray-900': active,
        })}
      >
        {institutionName}
      </p>
      {isNew && (
        <div className="absolute bottom-30 left-1/2 -translate-x-1/2">
          <NewBadge dimensions="H16" />
        </div>
      )}
    </Button>
  );
};
